module.exports = __webpack_public_path__ + "img/EconomyTabClicked_ua.c36fa4fe.webp";